import React, { useCallback, useState } from 'react';

const DisplayVideo = ({ file }) => {
    const [videoReady, setVideoReady] = useState(false);
    const [play, setPlay] = useState(false);
    const [mute, setMute] = useState(false);
    const timeUpdate = useCallback(() => {
        const video = document.querySelector('#video');
        if (videoReady) {
            const percentage = (video.currentTime / video.duration) * 100;
            document.querySelector(
                '#seek-bar span'
            ).style.width = `${percentage}%`;
        }
    }, [videoReady]);

    const onClickBar = useCallback((e) => {
        const video = document.querySelector('#video');
        const offset = e.target.getBoundingClientRect();
        const left = e.pageX - offset.left;
        const totalWidth = document.querySelector('#seek-bar').clientWidth;
        const percentage = left / totalWidth;
        const vidTime = video.duration * percentage;
        video.currentTime = vidTime;
    }, []);

    const PlayPauseVideo = useCallback(() => {
        const video = document.querySelector('#video');
        if (play) {
            video.pause();
            setPlay(false);
        } else {
            video.play();
            setPlay(true);
        }
    }, [play]);

    const MuteVideo = useCallback(() => {
        const video = document.querySelector('#video');
        video.muted = Boolean(mute);
        setMute(!video.muted);
    }, [mute]);

    const openFullscreen = useCallback(() => {
        const video = document.querySelector('#video');
        if (video.requestFullscreen) {
            video.requestFullscreen();
        } else if (video.mozRequestFullScreen) {
            /* Firefox */
            video.mozRequestFullScreen();
        } else if (video.webkitRequestFullscreen) {
            /* Chrome, Safari and Opera */
            video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) {
            /* IE/Edge */
            video.msRequestFullscreen();
        }
    }, []);

    const getVideoDuration = useCallback(() => {
        const video = document.querySelector('#video');
        if (videoReady) {
            const str_pad_left = (string, pad, length) => {
                return (new Array(length + 1).join(pad) + string).slice(
                    -length
                );
            };
            const duration = parseInt(video.duration, 10);
            const minutes = Math.floor(duration / 60);
            const seconds = duration - minutes * 60;

            return `${str_pad_left(minutes, '0', 2)}:${str_pad_left(
                seconds,
                '0',
                2
            )}`;
        }
        return '00:00';
    }, [videoReady]);

    return (
        <>
            <div className="add-media-box">
                <video
                    id="video"
                    className="add-media-player"
                    src={file.src || file}
                    onCanPlayThrough={() => {
                        setVideoReady(true);
                    }}
                    onTimeUpdate={timeUpdate}
                />
                <div
                    id="video-controls"
                    className="video-controls media-controls">
                    <button
                        type="button"
                        id="play-pause"
                        className="btn btn-play"
                        onClick={PlayPauseVideo}>
                        {play ? (
                            <span className="fa fa-pause"></span>
                        ) : (
                            <span className="fa fa-play"></span>
                        )}
                    </button>
                    <div
                        id="seek-bar"
                        className="video-progress-bar"
                        value={0}
                        max={100}
                        onClick={onClickBar}>
                        <span style={{ width: '0%' }} />
                    </div>
                    <p className="video-duration">{getVideoDuration()}</p>
                    <button
                        type="button"
                        id="mute"
                        className="btn btn-mute"
                        onClick={MuteVideo}>
                        {mute ? (
                            <span className="fa fa-volume-off"></span>
                        ) : (
                            <span className="fa fa-volume-up"></span>
                        )}
                    </button>
                    <button
                        type="button"
                        id="full-screen"
                        className="btn btn-fullscreen"
                        onClick={openFullscreen}>
                        <span className="fa fa-expand"></span>
                    </button>
                </div>
            </div>
        </>
    );
};

export default DisplayVideo;
